export default __webpack_public_path__ + "static/media/medical_15.fa6745e8.jpg";